/**
 * Format both fixed and arm terms
 *
 * @param term
 * @param yrReplacement
 * @returns
 */
export const renameTerm = (term: string, yrReplacement: string) => {
  return term.replace('yr', ` ${yrReplacement}`).replace('-1arm', ' year ARM').replace('-6arm', ' year ARM')
}

/**
 * Format a list of fixed/arm terms and remove duplicates
 *
 * @param terms
 * @param yrReplacement
 * @returns
 */
function formatTerms(terms: string[], yrReplacement: string) {
  return terms
    .map(loanTerm => renameTerm(loanTerm, yrReplacement))
    .reduce((acc: string[], value: string) => {
      // Remove any duplicates, ARM selections add the same name for both /1 and /6
      if (!acc.includes(value)) {
        acc.push(value)
      }

      return acc
    }, [])
}

export const formatTermsWithYearFixed = (terms: string[]) => {
  return formatTerms(terms, 'year fixed')
}

export const formatProductsText = (products: string[]) => {
  const productNames = formatTermsWithYearFixed(products)
  return productNames.length > 1
    ? productNames.length === 2
      ? productNames[0] + ' and ' + productNames[1]
      : productNames.slice(0, -1).join(', ') + ', and ' + productNames.slice(-1)
    : productNames[0]
}
